import {
  deleteRequest,
  get,
  post,
} from "services/BaseClient/Client";
import headers from "services/BaseClient/Headers.json";
import { DataResponse } from "services/BaseClient/BaseResponseModel";
import endpoints from "./EndPoints";
import { CreateUrlFilter } from "helpers/CreateURLFilter";


export const  getMessageGroupList = async (filter:any): Promise<DataResponse<any>> => {
  const query = filter?CreateUrlFilter(filter):null
  const url = `${endpoints.getMessageGroupList}?${query||""}`;
  const config = headers.content_type.application_json;
  return get<DataResponse<any>>(url, config);
};

export const  getMessageGroupDetail= async (filter:any): Promise<DataResponse<any>> => {
  const query = filter?CreateUrlFilter(filter):null
  const url = `${endpoints.getMessageGroupDetail}?${query||""}`;
  const config = headers.content_type.application_json;
  return get<DataResponse<any>>(url, config);
};


export const  changeUserBlockStatus= async (data:any): Promise<DataResponse<any>> => {
  const url = `${endpoints.changeUserBlockStatus}`;
  const config = headers.content_type.application_json;
  return post<DataResponse<any>>(url, data,config);
};

export const  reportUser= async (data:any): Promise<DataResponse<any>> => {
  const url = `${endpoints.reportUser}`;
  const config = headers.content_type.application_json;
  return post<DataResponse<any>>(url, data,config);
};

export const  complaintByUser= async (data:any): Promise<DataResponse<any>> => {
  const url = `${endpoints.complaintByUser}`;
  const config = headers.content_type.application_json;
  return post<DataResponse<any>>(url, data,config);
};


export const  deleteAllMessages= async (data:any): Promise<DataResponse<any>> => {
  const url = `${endpoints.deleteAllMessages}`;
  const config = headers.content_type.application_json;
  return deleteRequest<DataResponse<any>>(url, data,config);
};




